import { useState } from "react";

const formUrl = "https://readdy.ai/api/form/da0r1juth95mubjtuj00";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = String(data.get("contact_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("感谢订阅，我们已经收到你的资讯偏好啦！");
      form.reset();
      return;
    }

    data.delete("contact_alt");

    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      payload.append(key, String(value));
    });

    setStatus("idle");
    setMessage("");
    try {
      const res = await fetch(formUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = /spam/i.test(responseText) || /spam/i.test(serverMsg || "");

      if (!res.ok || isSpam || !parsed || parsed.code !== "OK") {
        setStatus("error");
        setMessage(serverMsg && serverMsg !== "OK" ? String(serverMsg) : "订阅失败，请稍后再试。");
        return;
      }

      setStatus("success");
      setMessage(parsed?.meta?.message || "订阅成功！我们会定期为你推送最新同人志与编辑精选。");
      form.reset();
    } catch {
      setStatus("error");
      setMessage("网络异常，订阅未能完成，请稍后重试。");
    }
  };

  return (
    <section id="contact" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 items-stretch gap-6 lg:grid-cols-5">
        <div className="relative overflow-hidden rounded-lg bg-primary-500 p-6 text-background-50 lg:col-span-2 md:p-8">
          <div className="relative z-10 flex h-full flex-col">
            <span className="inline-flex w-fit items-center gap-2 rounded-full bg-background-50/15 px-3 py-1 text-xs">
              <i className="ri-mail-send-line"></i>
              订阅我们
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold md:text-3xl">
              不错过任何一部
              <br />
              宝藏同人志
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-100/90">
              留下你的邮箱，我们会定期推送最新上线作品、本周热门榜单与编辑精选专栏，让好内容自动找上门。
            </p>

            <div className="mt-auto space-y-3 pt-6 text-sm">
              <a href="mailto:hello@doujinshi.example.com" className="flex items-center gap-3 text-background-100 hover:text-background-50">
                <i className="ri-mail-line"></i>
                hello@doujinshi.example.com
              </a>
              <div className="flex items-center gap-3 text-background-100">
                <i className="ri-time-line"></i>
                在线平台 · 7×24 小时随时翻阅
              </div>
            </div>
          </div>
        </div>

        <form
          data-readdy-form="同人志资讯订阅表单"
          id="subscribe-form"
          onSubmit={onSubmit}
          className="flex flex-col justify-center rounded-lg border border-background-200/70 bg-background-50 p-6 lg:col-span-3 md:p-8"
        >
          <h3 className="font-heading text-lg font-bold text-foreground-950">订阅同人志资讯</h3>
          <p className="mt-1 text-xs text-foreground-500">填写下方信息，即可订阅最新作品与精选推送。</p>

          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label htmlFor="sub-name" className="mb-1.5 block text-xs font-medium text-foreground-700">
                你的称呼
              </label>
              <input
                id="sub-name"
                name="name"
                type="text"
                placeholder="例如：小林"
                className="w-full rounded-md border border-background-200 bg-background-100/50 px-3 py-2.5 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-300 focus:ring-2 focus:ring-primary-100"
              />
            </div>
            <div>
              <label htmlFor="sub-email" className="mb-1.5 block text-xs font-medium text-foreground-700">
                常用邮箱 <span className="text-primary-600">*</span>
              </label>
              <input
                id="sub-email"
                name="email"
                type="email"
                required
                placeholder="you@example.com"
                className="w-full rounded-md border border-background-200 bg-background-100/50 px-3 py-2.5 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-300 focus:ring-2 focus:ring-primary-100"
              />
            </div>
          </div>

          <div className="mt-4">
            <label htmlFor="sub-topic" className="mb-1.5 block text-xs font-medium text-foreground-700">
              你偏爱的题材（可选）
            </label>
            <textarea
              id="sub-topic"
              name="topic"
              rows={3}
              maxLength={500}
              placeholder="例如：校园日常、奇幻冒险、治愈系画集……"
              className="w-full resize-none rounded-md border border-background-200 bg-background-100/50 px-3 py-2.5 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-300 focus:ring-2 focus:ring-primary-100"
            ></textarea>
            <p className="mt-1 text-right text-[11px] text-foreground-400">最多 500 字</p>
          </div>

          <input
            type="text"
            name="contact_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="site_alt_fld"
          />

          <button
            type="submit"
            className="mt-5 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            立即订阅
          </button>

          {status === "success" && (
            <p className="mt-4 flex items-start gap-2 rounded-md bg-secondary-100 px-3 py-2.5 text-sm text-secondary-900">
              <i className="ri-checkbox-circle-fill mt-0.5"></i>
              {message}
            </p>
          )}
          {status === "error" && (
            <p className="mt-4 flex items-start gap-2 rounded-md bg-primary-100 px-3 py-2.5 text-sm text-primary-800">
              <i className="ri-error-warning-fill mt-0.5"></i>
              {message}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}